import * as R from 'ramda'

export const auditStatusText = {
  APPROVED: '审核已通过',
  PENDING: '待审核',
  REJECT: '审核未通过'
}

export function auditCodes () {
  return R.keys(auditStatusText)
}
export function auditOptions () {
  return R.values(auditStatusText)
}
